import React from "react";
import { Col, Card } from "antd";
import {
  AreaChart,
  Area,
  BarChart,
  Bar,
  LineChart,
  Line,
  XAxis,
  YAxis,
  Tooltip,
  ResponsiveContainer,
  CartesianGrid
} from "recharts";

const DashboardCharts = () => {

  const areaData = [
    { day: "Mon", pnl: 200 },
    { day: "Tue", pnl: 500 },
    { day: "Wed", pnl: 700 },
    { day: "Thu", pnl: 900 },
    { day: "Fri", pnl: 1200 }
  ];

  const barData = [
    { name: "Wins", value: 32 },
    { name: "Loss", value: 18 }
  ];

  const lineData = [
    { week: "W1", score: 60 },
    { week: "W2", score: 65 },
    { week: "W3", score: 70 },
    { week: "W4", score: 78 }
  ];

  return (
    <>
      {/* Lincfolio Score */}
      <Col md={8} xs={24}>
        <Card title="Lincfolio Score">
          <ResponsiveContainer width="100%" height={250}>
            <LineChart data={lineData}>
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis dataKey="week" />
              <YAxis />
              <Tooltip />
              <Line type="monotone" dataKey="score" stroke="#8e44ad" strokeWidth={3}/>
            </LineChart>
          </ResponsiveContainer>
        </Card>
      </Col>

      {/* Equity Curve */}
      <Col md={8} xs={24}>
        <Card title="Equity Curve">
          <ResponsiveContainer width="100%" height={250}>
            <AreaChart data={areaData}>
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis dataKey="day" />
              <YAxis />
              <Tooltip />
              <Area type="monotone" dataKey="pnl" stroke="#2980b9" fill="#2980b9" fillOpacity={0.3}/>
            </AreaChart>
          </ResponsiveContainer>
        </Card>
      </Col>

      {/* Win vs Loss */}
      <Col md={8} xs={24}>
        <Card title="Win vs Loss">
          <ResponsiveContainer width="100%" height={250}>
            <BarChart data={barData}>
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis dataKey="name" />
              <YAxis />
              <Tooltip />
        <Bar dataKey="value" fill="#27ae60" barSize={50} />
            </BarChart>
          </ResponsiveContainer>
        </Card>
      </Col>
    </>
  );
};

export default DashboardCharts;